import { render } from "./List_Groups.vue?vue&type=template&id=74c755dd&scoped=true"
import script from "./List_Groups.vue?vue&type=script&lang=js"
export * from "./List_Groups.vue?vue&type=script&lang=js"

import "./List_Groups.vue?vue&type=style&index=0&id=74c755dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c755dd"]])

export default __exports__